module.exports = __webpack_public_path__ + "img/consulting.e31a9e80.svg";